package com.eladfinish.bible.contest.di.config

import org.koin.core.module.Module
import org.koin.dsl.module

class KoinConfiguration(
    private val appInfo: AppInfo,
    private val debugInfo: DebugInfo,
) {

    val module: Module
        get() = module {
            single { appInfo }
            single { debugInfo }
        }
}
